module.exports = __webpack_public_path__ + "static/media/android-chrome-192x192.e11fd044.png";